import React, { Component } from "react";
import { connect } from "react-redux";
import { withNamespaces } from "react-i18next";

// Components 
import NoRecords from "../../../components/NoRecords/NoRecords";

import { getLatest } from "../../../store/ducks/history/actions";
import { numFormat } from "../../../hoc/Shared/utility";

class BettingHistory extends Component {
  constructor(props) {
    super(props);
    this.state = {

    };
  }

  render() {
    const { t, i18n } = this.props;
    let data = this.props.latestBetData ? this.props.latestBetData : [];
    const num_format = numFormat(this.props.currentUser.currency);
    return (
      <>
        {!this.props.loading && data.length>0 &&
        <div className="pd-content">
          <div className="pi-bh-col">
            <ul className="list-group list-group-flush">
                {data.map((item, index) => {
                  let gn_val = "";
                  if(item.gameName !== null){
                    if(item.gameTitle === null && i18n.exists(`games:${item.gameVendorSlug}.${item.gameName}`)){
                      gn_val = t(`games:${item.gameVendorSlug}.${item.gameName}`);
                    }
                    else if(item.gameTitle === null && !i18n.exists(`games:${item.gameVendorSlug}.${item.gameName}`)){
                      gn_val = item.gameName;
                    }
                    else{
                      gn_val = item.gameTitle;
                    }
                  }else{
                    gn_val = item.gameName;
                  }
                  return (
                  <li className="list-group-item" key={index}>
                    <span>
                      <label>{t("profile.date")}</label>
                      <p>{item.update_date}</p>
                    </span>
                    <span>
                      <label>{t("profile.game-provider")}</label>
                      <p>{t(`vendor.${item.gameVendorSlug}`)}</p>
                    </span>
                    <span>
                      <label>{t("profile.category")}</label>
                      <p>{t(`game-type.${item.category}`)}</p>
                    </span>
                    <span>
                      <label>{t("profile.game-name")}</label>
                      <p>{gn_val}</p>
                    </span>
                    <span>
                      <label>{t("profile.bet-amount")}</label>
                      <p>{new Intl.NumberFormat("en-US", num_format).format(item.bet_amount)}</p>
                    </span>
                    <span>
                      <label>{t("profile.turnover")}</label>
                      <p>{new Intl.NumberFormat("en-US", num_format).format(item.turnover)}</p>
                    </span>
                  </li>
                  )
                })}
            </ul>
          </div>
        </div>
        }
        {!this.props.loading && data.length===0 &&
          <NoRecords component="betting-history"/>
        }
      </>
    );
  }
}

const mapStateToProps = state => {
  return {
    latest: state.history.latest,
    currentUser: state.currentUser.data
  }
}

const mapDispatchToProps = {
  getLatest
}

export default connect(mapStateToProps,mapDispatchToProps)(withNamespaces("translation")(BettingHistory));
